import React, { useEffect, useRef, useState } from 'react';
import UserService from '../services/UserService';
import "../styles/LoginModal.css";
import { Utils } from '../services/Utils';
interface LoginModalProps {
  isActive: boolean;
  toggleModal: () => void;
  onSuccess: (token: string, userName: string, loginid: string) => void; // Callback after successful login
}

const LoginModal: React.FC<LoginModalProps> = ({
  isActive,
  toggleModal,
  onSuccess,
}) => {
  //const [isActive, setIsActive] = useState(false);
  const [contact, setContact] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [validationMsg, setValidationMsg] = useState('');
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const brandName = "Strech";
  const otpInputs = useRef<HTMLInputElement[]>([]);
  useEffect(() => {
    otpInputs.current = otpInputs.current.slice(0, 6);
  }, []);
  useEffect(() => {
    if (isActive) {
      document.body.classList.add("modal-active");
    } else {
      document.body.classList.remove("modal-active");
    }
  }, [isActive]);
  const handleContactChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setContact(e.target.value);
  };
  const handleOTPChange = (index: number, value: string) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move focus to the next input or blur if it's the last one
    if (value && index < 5) {
      otpInputs.current[index + 1].focus();
    } else if (index === 5) {
      otpInputs.current[index].blur(); // Optional: Blur on last digit
    }
  };
  const handleBackspace = (index: number) => {
    const newOtp = [...otp];
    if (!newOtp[index] && index > 0) {
      otpInputs.current[index - 1].focus();
      newOtp[index - 1] = '';
    }
    newOtp[index] = '';
    setOtp(newOtp);
  };
  const handleBackToLogin = async () => {
    setOtpSent(false);
    setValidationMsg('')
  }
  const handleCancelLogin = async () => {
    setValidationMsg('')
    toggleModal()
  }
  const handleSendOTP = async () => {
    // Here you would typically make an API call to send the OTP
    // For this example, we'll just simulate it
    const loginBody = {
      userName: contact,
    };
    if ("invalid" != Utils.validateUsernameInput(contact)) {
      await UserService.triggerOTPForValidation(loginBody);
      console.log(`Sending OTP to ${contact}`);
      setOtpSent(true); setValidationMsg('');

    } else {
      setValidationMsg("Enter a valid Email/Mobile Number")
    }
  };

  const handleVerifyOTP = async () => {

    const enteredOTP = otp.join('');
    if (enteredOTP.length == 6) {
      const loginBody = {
        userName: contact,
        otp: enteredOTP,
      };
      const userDetails = await UserService.verifyOtpAndFetchUser(loginBody);
      if (userDetails) {
        // Dispatch login action to update Redux state
        onSuccess(userDetails.token.token, userDetails.userFirstName, contact);
        toggleModal();
      } else {
        setValidationMsg("Invalid OTP");
      }
      // Here you would typically make an API call to verify the OTP
      // For this example, we'll just simulate it
      console.log(`Verifying OTP: ${otp}`);
      // If OTP is correct, close the modal or redirect      
    } else {
      setValidationMsg("Enter a valid OTP");
    }

  };

  return (
    <div className='login-container'>
      <div className={`modal ${isActive ? 'is-active' : ''}`}>
        <div className="modal-background" onClick={toggleModal}></div>
        <div className="modal-card has-text-centered">
          <header className="modal-card-head">
            <p className="modal-card-title">Login</p>
            <button className="delete" aria-label="close" onClick={toggleModal}></button>
          </header>
          <section className="modal-card-body">
            {!otpSent && ( // Contact input
              <div>
                <div className="field">
                  <label className="label is-size-5">Welcome to {brandName}</label>
                  <div className="control">
                    <input
                      className="input"
                      type="text"
                      placeholder="Enter Email"
                      value={contact}
                      onChange={handleContactChange}
                    />
                  </div>
                </div>

              </div>
            )}

            {otpSent && ( // OTP input
              <div>
                <div className='is-size-6	py-3'>OTP sent to <strong>{contact}</strong >  . Please enter it below:</div>
                <div className="field is-grouped"> {/* Use grouped fields for the boxes */}
                  {[0, 1, 2, 3, 4, 5].map((index) => (
                    <div className="control" key={index}>
                      <input
                        className="input otp-input" // Add a class for styling
                        type="text"
                        maxLength={1}
                        value={otp[index]}
                        ref={(el) => (otpInputs.current[index] = el!)}
                        onChange={(e) => handleOTPChange(index, e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Backspace') { handleBackspace(index) } }}
                        style={{ width: '40px', textAlign: 'center' }} // Adjust width as needed
                      />
                    </div>
                  ))}
                </div>

              </div>
            )}
            <div className='is-size-5	py-3 has-text-danger'>{validationMsg}</div>
          </section>
          <footer className="modal-card-foot">
            <div className='buttons'>
              {otpSent ? <div className="field">
                <div className="control">
                  <button className="button is-primary" onClick={handleVerifyOTP}>Verify OTP</button>
                </div>
              </div> : <div className="field">
                <div className="control">
                  <button className="button is-primary" onClick={handleSendOTP}>Send OTP</button>
                </div>
              </div>}
              {otpSent ? <div className="field">
                <div className="control">
                  <button className="button is-primary" onClick={handleBackToLogin}>Back</button>
                </div>
              </div> : <div className="field">
                <div className="control">
                  <button className="button is-primary" onClick={handleCancelLogin}>Cancel</button>
                </div>
              </div>}
            </div>


            {/* You can add other footer buttons here if needed */}
            {/* <button className="button" onClick={toggleModal}>Cancel</button> */}
          </footer>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
